import { render, staticRenderFns } from "./form-discount.vue?vue&type=template&id=04b44397&scoped=true&"
import script from "./form-discount.vue?vue&type=script&lang=js&"
export * from "./form-discount.vue?vue&type=script&lang=js&"
import style0 from "./form-discount.vue?vue&type=style&index=0&id=04b44397&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b44397",
  null
  
)

export default component.exports